import { Message } from 'element-ui';
import { uploadOSS } from '../api/accountManage';
import store from "@/store";
import MD5 from 'js-md5';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios'


// 默认图片文件格式
export const imgFormat = [".jpg", ".jpeg", ".png", ".gif", ".JPG", ".JPEG", ".PNG", ".GIF"];

// 获取oss签名
let ossToken = null;
async function getCredential() {
  const { data } = await uploadOSS().catch(() => {
    Message({
      message: '获取上传签名配置失败',
      type: "error"
    });
  });
  ossToken = data;
}

// 上传文件
export async function uploadFile(fileObj, path, isFullPath = false) {
  debugger
  let time = new Date().getTime();
  let isExpired = false;
  if (ossToken) {
    isExpired = ossToken.expireTime - time <= (1000 * 60); // 根据后台返回过期时间判断是否过期
  } else {
    isExpired = true;
  }
  if (!ossToken || isExpired) {
    await getCredential();
  }
  return commonUpload(fileObj, path, ossToken, isFullPath);
}

// 生成文件名和路径
export function getFileName() {
  let str = MD5(String(store.getters.orgCode)).substring(0, 6) + '/' + store.getters.orgCode + '/' + uuidv4();
  return str;
}


// 普通上传
async function commonUpload(blob = {}, path, credentials, isFullPath) {
  // blob.timestamp = getFileName();
  blob.timestamp = new Date().getTime();
  const formData = new FormData();
  // 配置文件名
  let fileName = calculate_object_name(blob, credentials.dir, path);
  formData.append('key', fileName); // 存储在oss的文件路径
  formData.append('policy', credentials.policy); // policy
  formData.append('OSSAccessKeyId', credentials.accessKeyId); // accessKeyId
  formData.append('success_action_status', 200); // 成功后返回的操作码
  formData.append('Signature', credentials.signature); // 签名
  formData.append('file', blob);
  let fileUrl = credentials.host;
  const result = await axios.post(fileUrl, formData);
  if (result.status === 200) {
    let fileSrc
    if (isFullPath) {
      fileSrc = credentials.host + '/' + fileName; // 返回全路径
    } else {
      fileSrc = '/' + fileName; // 返回key
    }
    return {
      status: true,
      size: (blob.size / 1024).toFixed(2),
      type: '.' + blob.type.split('/')[1],
      name: blob.name,
      fileSrc
    };
  } else {
    return {
      status: false
    };
  }
}

/**
 * 生成图片路径
 * @param thefile 文件
 * @param dir 上传地址
 * @param path oss存储的模块
*/
function calculate_object_name(thefile, dir, path) {
  var suffix = get_suffix(thefile.type);
  var g_object_name;
  if (path) {
    g_object_name = dir + path + '/' + getDate() + '/' + thefile.timestamp + "." + suffix;
  } else {
    g_object_name = dir + getDate() + '/' + thefile.timestamp + "." + suffix;
  }
  return g_object_name;
}

// 获取今天日期
function getDate() {
  var nowDate = new Date();
  var year = nowDate.getFullYear();
  var month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1) : nowDate.getMonth() + 1;
  var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
  var dateStr = year + "" + month + "" + day;
  return dateStr;
}
// 截取文件名
function get_suffix(type) {
  var pos = type.lastIndexOf("/");
  var suffix = "";
  if (pos !== -1) {
    suffix = type.substring(pos + 1);
  }
  return suffix;
}

/**
 * 文件限制
 * @param target 文件输入框
 * @param restrictSize 限制的文件大小
 * @param filetype 文件限制类型列表
 * */
export function fileAstrict(target, filetype, restrictSize = 5) {
  var fileSize = target.size || target.files[0].size;
  var filepath = target.name || target.value;
  var filemaxsize = 1024 * restrictSize; // 限制小于10M文件
  var filetypes = filetype || imgFormat;
  if (filepath) {
    var isnext = false;
    var fileend = filepath.substring(filepath.lastIndexOf("."));
    if (filetypes && filetypes.length > 0) {
      for (var i = 0; i < filetypes.length; i++) {
        if (filetypes[i] === fileend) {
          isnext = true;
          break;
        }
      }
    }
    if (!isnext) {
      Message({
        type: 'error',
        message: `只接受 ${filetypes.toString()} 文件类型！`
      });
      target.value = "";
      return false;
    }
  } else {
    return false;
  }
  var size = fileSize / 1024;
  if (size > filemaxsize) {
    Message({
      type: 'error',
      message: "文件大小不能大于" + filemaxsize / 1024 + "M！"
    });
    target.value = "";
    return false;
  }
  if (size <= 0) {
    Message({
      type: 'error',
      message: "文件大小不能为0M！"
    });
    target.value = "";
    return false;
  }
  return true;
}
